module.exports = __webpack_public_path__ + "img/icon_red_bag.11f2be23.png";